import React from "react";
import ConfirmationDialog from "@/lib/components/ConfirmationDialog";
import {useTranslation} from "react-i18next";
import {RequestI18N} from "@/translations";

/**
 * Props for the UnsavedChangesDialog component.
 *
 * @property {boolean} open - Whether the dialog is open.
 * @property {() => void} onConfirm - Function to call when the confirm action is triggered.
 * @property {() => void} onCancel - Function to call when the cancel action is triggered.
 * @property {(key: string) => string} t - Function to translate keys to localized strings.
 */
export interface UnsavedChangesDialogProps {
    open: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

/**
 * UnsavedChangesDialog component.
 *
 * @param {UnsavedChangesDialogProps} props - The props for the component.
 * @returns {React.ReactElement} The rendered UnsavedChangesDialog component.
 */
export const UnsavedChangesDialog = ({ open, onConfirm, onCancel }: UnsavedChangesDialogProps): React.ReactElement => {
    const { t } = useTranslation();
    return (
        <ConfirmationDialog
            open={open}
            onClose={onCancel}
            onConfirm={onConfirm}
            title={t(RequestI18N.details.dialog.discardTitle)}
            message={t(RequestI18N.details.message.unsavedChanges)}
            confirmButtonText={t(RequestI18N.details.action.discard)}
            cancelButtonText={t(RequestI18N.details.action.stay)}
            maxWidth="sm"
            fullWidth
        />
    );
};
